"use client";

import type { ReactNode } from "react";
import { NuqsAdapter as BaseNuqsAdapter } from "nuqs/adapters/next/app";

interface NuqsAdapterProps {
  children: ReactNode;
}

export function NuqsAdapter({ children }: NuqsAdapterProps) {
  return <BaseNuqsAdapter>{children}</BaseNuqsAdapter>;
}
